import { z } from 'zod';
import { API_PREFIX } from './auth.js';

/** Owner-only analytics. Answers only to the STATS_TOKEN set on the server. */
export const STATS_PATH = `${API_PREFIX}/admin/stats`;

const count = z.number().int().min(0);
const windows = z.object({ day: count, week: count, month: count });

/**
 * Totals worked out from what the game already stores to run itself. Nothing here comes
 * from tracking: no page views, no device data, nothing that identifies a player.
 */
export const statsResponseSchema = z.object({
  generatedAt: z.string(),
  players: z.object({
    total: count,
    registered: count,
    /** Browsers with the game open right now. */
    onlineNow: count,
    new: windows,
    active: windows,
  }),
  matches: z.object({
    waiting: count,
    playing: count,
    completed: count,
    cancelled: count,
    completedPublic: count,
    completedPrivate: count,
    completedRecent: windows,
    /** From the lobby opening to the front page. */
    averageMinutes: z.number().nullable(),
    averageHumans: z.number().nullable(),
    /** Share of seats in finished matches taken by computer players, 0 to 1. */
    botSeatShare: z.number().nullable(),
  }),
  outcomes: z.object({ plot: count, detail: count }),
  countries: z.array(
    z.object({ countryId: z.string(), votes: count, played: count, plotWins: count }),
  ),
  endings: z.array(z.object({ countryId: z.string(), endingId: z.string(), count })),
  /** The last 30 days, oldest first, by UTC date. */
  daily: z.array(
    z.object({
      day: z.string(),
      newPlayers: count,
      matchesStarted: count,
      matchesCompleted: count,
    }),
  ),
});
export type StatsResponse = z.infer<typeof statsResponseSchema>;
